// extracted by mini-css-extract-plugin
export default {"wrapper":"AppImplantPage_wrapper__132HC"};